import React, { ReactNode } from 'react';
import classNames from 'classnames';

import './Step.scss';

type StepProps = {
  isActive: boolean;
  children: ReactNode;
};

export const Step: React.FC<StepProps> = (props) => {
  return (
    <li
      className={classNames({
        'dmx-newOrderStep': true,
        'dmx-newOrderStep-isActive': props.isActive,
      })}
    >
      {props.children}
    </li>
  );
};
